import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CorporateService } from 'src/app/services/corporate.service';
import { CommonfilterService } from 'src/app/services/commonfilter.service';

@Component({
  selector: 'app-view-corporate',
  templateUrl: './view-corporate.component.html',
  styleUrls: ['./view-corporate.component.css']
})
export class ViewCorporateComponent implements OnInit {
  corporateDetails: any;

  constructor(
    private activatedRoute: ActivatedRoute,
     private corporateService: CorporateService,
      private router: Router,
      private commonService: CommonfilterService) {
    this.corporateService.getDetails(this.activatedRoute.snapshot.params['id'])
    .subscribe(res => {
      this.corporateDetails = res;
    });
   }
  ngOnInit() {

  }
  getDomainName(sectorId) {
    return this.corporateService.getDomainName(sectorId);
    }
    getSubDomainName(sectorId, subSectorId) {
      return this.corporateService.getSubDomainName(sectorId, subSectorId);
    }
  goBacktoList() {
    this.router.navigate(['../../list'], { relativeTo: this.activatedRoute });
  }

}
